//动态获取线上地址  配置图片路径
const imagesSrc = `${location.origin}/static/images`

const appConfig = {
  //站点主名称
  siteName: '9JOGOS.com',

  //applog的图片路径
  logo: `${imagesSrc}/logo.png`,
  logoUrl: `${imagesSrc}/logo-120.png`,
  nationName: 'pt',

  // 国旗
  nationFlag: `${imagesSrc}/guoqi_brazil.png`,
  nationCode: '+55',

  // 主题
  themes: {
    theme_a: {
      getTheme: () => import('@/router/theme_a'),
    },

    theme_b: {
      getTheme: () => import('@/router/theme_b'),
    },
  },

  // 支持的语言
  // languages: ['pt', 'en'],

  // 开屏图片
  openningImage: `${imagesSrc}/loadingPage.jpg`,

  // 环境检测时间
  detectTime: 15000,

  // pwa安装时间
  installTime: 15000,

  brandList: [
    { id: 1, imgUrl: `${imagesSrc}/gblogo_1.png` },
    { id: 2, imgUrl: `${imagesSrc}/gblogo_2.png` },
    { id: 3, imgUrl: `${imagesSrc}/gblogo_3.png` },
    { id: 4, imgUrl: `${imagesSrc}/gblogo_4.png` },
    { id: 5, imgUrl: `${imagesSrc}/gblogo_5.png` },
    { id: 6, imgUrl: `${imagesSrc}/gblogo_6.png` },
  ],

  //媒体链接  imgUrl  图片链接  goUrl  跳转链接
  mediaList: [
    {
      mediaName: '18',
      imgUrl: `${imagesSrc}/18age.png`,
      goUrl: '',
    },
    {
      mediaName: 'Facebook',
      imgUrl: `${imagesSrc}/facebook_cai.png`,
      goUrl: 'https://www.facebook.com/profile.php?id=61565981095938',
    },
    {
      mediaName: 'Telegram',
      imgUrl: `${imagesSrc}/telegram_cai.png`,
      goUrl: 'https://t.me/Agente_9jogos',
    },
    {
      mediaName: 'WhatsApp',
      imgUrl: `${imagesSrc}/whatsapp.png`,
      goUrl: 'https://www.whatsapp.com/channel/0029VaejutjEwEjrZ74old3Q',
    },

    {
      mediaName: 'Instagram',
      imgUrl: `${imagesSrc}/insgram_cai.png`,
      goUrl: 'https://www.instagram.com/9jogoscom/',
    }
  ]
}

export default appConfig
